import { useAppContext } from '@contexts/app';
import { useWebsocketContext } from '@contexts/websocket';
import { localStore } from '@utils/localStore';
import { endSession, SessionEndReason, SessionKey } from '@utils/session';
import { initialState } from '@contexts/app/constants';
import { useQueryClient } from '@tanstack/react-query';
import posthog from 'posthog-js';
import * as Sentry from '@sentry/react';

export const useLogout = () => {
  const { setData } = useAppContext();
  const { ws } = useWebsocketContext();

  const queryClient = useQueryClient();

  return (type: 'admin' | 'user', reason: SessionEndReason) => {
    const sessionKeys: SessionKey[] = localStore.getItem('app-impersonate')
      ? ['app-user', 'app-admin']
      : [`app-${type}`];
    endSession(reason, [...sessionKeys, 'app-foreman', 'app-impersonate'], type);
    posthog?.reset();
    Sentry.setUser(null);
    queryClient.removeQueries();
    ws?.disconnect();
    if (type === 'admin') setData((prev) => ({ ...prev, admin: initialState.admin }));
    else setData((prev) => ({ ...initialState, admin: prev.admin }));
  };
};
